import getFetchOptions from 'utils/getFetchOptions';

import { PaginatedResponse, handlePaginatedResponse, handleResponse, toQueryString } from '../utils';
import { JournalEntriesQueryParams, ManualTopUpRequest } from './journal.types';

export const getJournalEntries = async (
  apiAprilBaseUri: string,
  queryParams: JournalEntriesQueryParams,
): Promise<PaginatedResponse<any>> => {
  let qParams = toQueryString(queryParams);
  const options = await getFetchOptions('GET');

  return await fetch(`${apiAprilBaseUri}/journals/entries${qParams}`, options).then(handlePaginatedResponse);
};

export const addJournalEntry = async (apiAprilBaseUri: string, payload: ManualTopUpRequest): Promise<string> => {
  const options = await getFetchOptions('POST', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/journals/entries`, options).then(handleResponse);
};
